export const RoomData = [
    {
        id:1 , 
        image:'./assets/image/svg/air-conditioner.svg',
        title:'هواساز'
    },
    {
        id:2 , 
        image:'./assets/image/svg/radiator.svg',
        title:'گرمایش'
    },
    {
        id:3 , 
        image:'./assets/image/svg/fan-cold.svg',
        title:'سرمایش',
    },
    {
        id:4 , 
        image:'./assets/image/svg/lighting.svg',
        title:'روشنایی'
    },
    {
        id:5 , 
        image:'./assets/image/svg/speaker.svg',
        title:'موسیقی'
    },
    {
        id:6 , 
        image:'./assets/image/air.png',
        title:'بخور گرم' 
    },
    {
        id:7 , 
        image:'./assets/image/svg/fragrance.svg',
        title:'رایحه'
    },
    {
        id:8 , 
        image:'./assets/image/svg/o2.svg',
        title:'اکسیژن'
    },
    {
        id:9 , 
        image:'./assets/image/svg/snow.svg',
        title:'بخور سرد'
    },
    
    
    
]